import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface RemoveOfferRowUseCase {
    invoke: (offerId : number, rowId : string) => Promise<boolean>;
  }
  
  export class RemoveOfferRow implements RemoveOfferRowUseCase {
    private offersPromoRepo: OffersPromoRepository;
    constructor(_OffersPromoRepo: OffersPromoRepository) {
      this.offersPromoRepo = _OffersPromoRepo;
    }
  
    async invoke(offerId : number, rowId : string){
       
        if(!rowId){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const deleted  = await this.offersPromoRepo.removeOfferRow(offerId, rowId);
        return deleted;
    }
  }